import { Sparkles, Loader2 } from "lucide-react";
import CategoryPicker from "./CategoryPicker";
import { resolveImageUrl } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";

export default function CategorizeRow({ row, onPick }) {
  const { t } = useLang();
  const isAi = row.choice && row.choice === row.suggestion;
  return (
    <li className="grid gap-6 sm:grid-cols-[160px_1fr] border-t border-zinc-800 py-8" data-testid={`bc-row-${row.id}`}>
      <img
        src={resolveImageUrl(row.thumb_url)}
        alt={row.title}
        loading="lazy"
        className="w-full sm:w-40 aspect-[4/3] object-cover bg-zinc-900"
      />
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-3 mb-4">
          <h3 className="font-serif text-xl text-zinc-50 truncate" data-testid={`bc-title-${row.id}`}>
            {row.title || "Untitled"}
          </h3>
          {row.suggesting && (
            <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500" data-testid={`bc-suggesting-${row.id}`}>
              <Loader2 size={12} className="animate-spin" /> {t("bc_suggesting")}
            </span>
          )}
          {isAi && (
            <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-sienna-400" data-testid={`bc-ai-badge-${row.id}`}>
              <Sparkles size={12} /> {t("bc_ai_badge")}
            </span>
          )}
          {!row.suggesting && !row.suggestion && !row.choice && (
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500" data-testid={`bc-no-suggestion-${row.id}`}>
              {t("bc_no_suggestion")}
            </span>
          )}
        </div>
        <CategoryPicker value={row.choice} onChange={(slug) => onPick(row.id, slug)} idPrefix={`bc-chip-${row.id}`} />
      </div>
    </li>
  );
}
